const CONTENT_UPDATES = [
  {
    id: "video-9yUTX5EDJFE-2026-09-03",
    type: "video",
    title: "Vídeo atualizado",
    message: "Automação",
    publishedAt: "2026-09-03T18:43:00-03:00",
    target: "videos",
  },
  {
    id: "video-cZSLhCNoqPo-2026-03-06",
    type: "video",
    title: "Novo vídeo disponível",
    message: "Posicionar seu Stop Loss com segurança",
    publishedAt: "2026-03-06T15:40:00-03:00",
    target: "videos",
  },
];

const STORAGE_KEY_PREFIX = "userpanel.read-content-notifications";

const getStorageKey = (userId) => `${STORAGE_KEY_PREFIX}:${userId || "anon"}`;

const readIdsFromStorage = (userId) => {
  try {
    const raw = localStorage.getItem(getStorageKey(userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeReadIdsToStorage = (userId, ids) => {
  localStorage.setItem(getStorageKey(userId), JSON.stringify(ids));
};

export const getUnreadContentNotifications = (userId) => {
  const readIds = new Set(readIdsFromStorage(userId));

  return CONTENT_UPDATES
    .filter((update) => !readIds.has(update.id))
    .sort(
      (a, b) =>
        new Date(b.publishedAt).getTime() - new Date(a.publishedAt).getTime()
    );
};

export const markContentNotificationAsRead = (userId, notificationId) => {
  const current = readIdsFromStorage(userId);
  if (current.includes(notificationId)) return;
  writeReadIdsToStorage(userId, [...current, notificationId]);
};

export const markAllContentNotificationsAsRead = (userId, notifications) => {
  const current = new Set(readIdsFromStorage(userId));
  notifications.forEach((notification) => current.add(notification.id));
  writeReadIdsToStorage(userId, Array.from(current));
};
